import { useQuery } from '@apollo/client';
import { PAGE_VERSION_SUMMARIES, PAGE_VERSION_SUMMARIES_LIMIT } from './pageEditorCache';

export { PAGE_VERSION_SUMMARIES_LIMIT };

const usePageVersionSummaries = ({ pageId }) => {
  const { data, loading, fetchMore, refetch } = useQuery(PAGE_VERSION_SUMMARIES, {
    variables: {
      pageId,
      limit: PAGE_VERSION_SUMMARIES_LIMIT,
      offset: 0,
    },
    skip: !pageId,
  });

  const summaries = data?.pageVersionSummaries || [];
  const hasMore = summaries.length >= PAGE_VERSION_SUMMARIES_LIMIT;

  const loadMore = () => fetchMore({
    variables: {
      pageId,
      limit: PAGE_VERSION_SUMMARIES_LIMIT,
      offset: summaries.length,
    },
    updateQuery: (prev, { fetchMoreResult }) => {
      if (!fetchMoreResult) return prev;
      const incoming = fetchMoreResult.pageVersionSummaries || [];
      const existingIds = new Set((prev.pageVersionSummaries || []).map(v => v._id));
      const merged = [
        ...(prev.pageVersionSummaries || []),
        ...incoming.filter(v => !existingIds.has(v._id)),
      ];
      return { ...prev, pageVersionSummaries: merged };
    },
  });

  return {
    summaries,
    loading,
    refetch,
    loadMore,
    hasMore,
  };
};

export default usePageVersionSummaries;
